export default {

  email:function(val){
    return /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(val);
  },

  phone:function(val){
    return /^1\d{10}$/.test(val);
  },
  idCard:function(val){
    return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(val);
  },
   arrayMin(value, rule, callback) {
      console.log('rule')
      console.log(rule)
      console.log('value')
      console.log(value)
      if (value.length < rule.min) {
        return false
      } else {
        return true
      }
    }


};


// WEBPACK FOOTER //
// ./src/utils/validator.js